import { CustomListLogic as CustomList } from './CustomList.logic'

export default CustomList
